// Modules
// =============================================================================

import $ from 'zepto';


// Class
// =============================================================================

export default class AdhView {
  constructor() {
    // Start
    this._toggle();
  }

  /**
   * this._toggle()
   * Toggle elements
   */
  _toggle() {
    const $elements = $('[data-toggle]');

    $.each($elements, (i, el) => {
      const $el = $(el);

      $el.on('click', (event) => {
        let selector = $el.data('toggle').selector;
        let classname = $el.data('toggle').classname;
        let $target = $(selector);

        if (!classname) {
          classname = 'is-visible';
        }

        if ($target.hasClass(`${classname}`))
          $target.removeClass(`${classname}`);
        else
          $target.addClass(`${classname}`);
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/js/views/adh-view.js